/**
 * Common Endpoints Index
 * Shared between HubAdmin and SuperAdmin
 */
export * from './auth.endpoints';
